class FetchSubjectTypes {
	constructor(public readonly accountId: number) {
		Object.freeze(this);
	}
}

export default FetchSubjectTypes;
